"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.symbol = symbol;
function symbol() {
    // eslint-disable-next-line max-len,quotes
    return '<symbol viewbox="0 0 16 16" id=icon-information-16><path d="M8 7a1 1 0 0 0-1 1v3a1 1 0 1 0 2 0V8a1 1 0 0 0-1-1Zm1-2a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z"></path><path d="M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8Zm2 0a6 6 0 1 0 12 0A6 6 0 0 0 2 8Z"></path></symbol>';
}
